import useModal from 'src/components/Modals/hooks/useModal';
import PreLaunchMarketWarningModal from 'src/components/PreLaunchMarketAlerts/PreLaunchMarketWarningAlert';

export default function WarningModals() {
	const { currentModal } = useModal();

	return (
		<>
			{currentModal?.type === 'pre_launch_market_warning' && (
				<PreLaunchMarketWarningModal {...currentModal.props} />
			)}
		</>
	);
}
